// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // baseurl:'http://192.168.100.16:9000/',
    baseurl:'https://api.racing-stats.com/',
    // baseurl:'http://167.114.96.66:9005/',
    // baseurl:'http://192.168.114.4:9005/',
}